import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
    selector: 'color-cell',
    template: '<material-color-picker (colorChanged)="onColorChanged($event)" [color]="params?.value"></material-color-picker>',
    styles: []
})
export class ColorCellComponent implements ICellRendererAngularComp {

    public params: any;

    agInit(params: any): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }

    onColorChanged(color: { class: string }): void {
        this.params.context.componentParent.setCellColor({ node: this.params.node, color: color.class });
    }
}
